import React from 'react';
import { Gavel } from '@mui/icons-material';

import { MonitoredAssuntoEyeIcon } from './MonitoredAssuntoEyeIcon';

interface LegislationNotificationIconProps {
  isMonitored: boolean;
  assuntoLabel?: string | null;
}

/** Ícone do sininho: martelo (norma nova) ou só olho (assunto monitorado). */
export function LegislationNotificationIcon({
  isMonitored,
  assuntoLabel,
}: LegislationNotificationIconProps) {
  if (isMonitored) {
    return <MonitoredAssuntoEyeIcon variant="icon" assuntoLabel={assuntoLabel} />;
  }
  return <Gavel fontSize="small" color="action" />;
}
